import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    fetch("/checkin_joypoint")
      .then((response) => {})
      .catch((response) => console.log(response.error));
  }
}
